<template>
    <flex-element :element-type="elementType" class="f-inline-flex">
        <input
            type="radio"
            :name="inputName"
            :checked="isChecked"
            :required="required"
            :aria-label="ariaLabel"
            :aria-labelledby="ariaLabelledBy"
            value="true"
            @input="onInput"
            @invalid="onInvalidInput"
        >
    </flex-element>
</template>

<script>
import baseAtom from '@/mixins/base-atom/base-atom-dumb';

const CHECKED_ATTR_NAME = 'checked-by-default';

export default {
    name: 'a-radio-button',
    mixins: [baseAtom],

    props: {
        inputName: {
            type: String,
            default: '',
        },

        required: {
            type: Boolean,
            default: false,
        },

        validationMessage: {
            type: String,
            default: '',
        },
    },

    data() {
        return {
            inputValueNew: false, // don't remove, needed for the "set cookie" logic in o-form-container
        };
    },

    computed: {
        isChecked() {
            return this.getElementData(CHECKED_ATTR_NAME);
        },
    },

    methods: {
        onInput(e) {
            e.target.setCustomValidity('');
            this.inputValueNew = e.target.checked;
        },

        onInvalidInput(e) {
            e.target.setCustomValidity(this.validationMessage);
        },
    },
};
</script>
